import { Space } from 'antd'
import CIMSCollapse from 'components/CIMSCollapse'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import RecipientsTags from 'components/CIMSTags/common/RecipientsTags'
import { useCASNotificationsContext } from '../../CASNotificationsContext'
import ApproverTags from '../ApproverTags'
import NotConfigured from './components/NotConfigured'
import { HelpMessage } from 'utils/constants'
import GroupFallback from '../GroupFallback'
import {
  CASNotificationEvent,
  FrequencyDefault,
  alphabeticalSort,
} from '@cims-online/shared'
import CIMSSection from 'components/CIMSSection'
import CIMSBasicFields from 'components/CIMSBasicFields'
import moment from 'moment'

const ViewCASNotifications: React.FC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  const { recipients, approverEvents, casNotifications, casRoutingGroups } =
    useCASNotificationsContext()
  const { every, byRoutingGroup } = recipients(event)
  const reviewNotification = casNotifications?.find(
    (notification) =>
      notification.notificationEventId ===
      CASNotificationEvent.RequestedReview.id
  )
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      {event === CASNotificationEvent.RequestedReview && (
        <CIMSSection title={`Requested Review Settings`}>
          <CIMSBasicFields
            fields={[
              {
                label: 'Days Before Review Date:',
                help: HelpMessage.CAS.Notifications.NotificationThreshold,
                children:
                  reviewNotification?.settings?.notificationThresholdDay ??
                  FrequencyDefault.THRESHOLD,
              },
              {
                label: 'Time of Day:',
                help: HelpMessage.CAS.Notifications.Frequency,
                children: moment({
                  hours:
                    reviewNotification?.settings?.frequency?.hour ??
                    FrequencyDefault.HOUR,
                  minutes:
                    reviewNotification?.settings?.frequency?.minute ??
                    FrequencyDefault.MINUTE,
                }).format('h:mm a'),
              },
            ]}
          />
        </CIMSSection>
      )}
      <CIMSSection
        help={HelpMessage.Notifications.Every(
          event,
          'Construction & Admin Submittal'
        )}
        title={`Every ${event.name} Event`}
      >
        <RecipientsTags
          noRecipientsContent={<NotConfigured type="Every" />}
          recipients={every}
        />
      </CIMSSection>

      {event.id !== CASNotificationEvent.Submitted.id && (
        <CIMSSection
          help={HelpMessage.CAS.Notifications.ByRoutingGroup(event)}
          title="Routing Groups"
        >
          <CIMSCollapse
            noPanelsContent={<GroupFallback />}
            panels={casRoutingGroups
              ?.sort(alphabeticalSort('name'))
              .map((routingGroup) => {
                const { id: key, name, description } = routingGroup
                const recipients = byRoutingGroup.find(
                  ({ routingGroup }) => routingGroup.id === key
                )?.recipients
                return {
                  key,
                  header: {
                    type: 'described',
                    name,
                    description,
                  },
                  children: (
                    <Space size="large" direction="vertical">
                      {approverEvents.some(
                        (approverEvent) => approverEvent.id === event.id
                      ) && <ApproverTags routingGroup={routingGroup} />}
                      <RecipientsTags
                        noRecipientsContent={
                          <NotConfigured type="Routing Group" name={name} />
                        }
                        recipients={recipients}
                      />
                    </Space>
                  ),
                }
              })}
          />
        </CIMSSection>
      )}
    </Space>
  )
}

export default ViewCASNotifications
